import { createIcon } from '@chakra-ui/react';

export const ReportOutlineIcon = createIcon({
  displayName: 'ReportOutlineIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="16"
        // height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          d="M2 15.1665H14"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.73332 6.08691H2.66667C2.3 6.08691 2 6.38691 2 6.75358V12.5002C2 12.8669 2.3 13.1669 2.66667 13.1669H3.73332C4.09998 13.1669 4.39998 12.8669 4.39998 12.5002V6.75358C4.39998 6.38691 4.09998 6.08691 3.73332 6.08691Z"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.53312 3.95996H7.46647C7.0998 3.95996 6.7998 4.25996 6.7998 4.62663V12.5C6.7998 12.8666 7.0998 13.1666 7.46647 13.1666H8.53312C8.89979 13.1666 9.19979 12.8666 9.19979 12.5V4.62663C9.19979 4.25996 8.89979 3.95996 8.53312 3.95996Z"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3334 1.8335H12.2668C11.9001 1.8335 11.6001 2.1335 11.6001 2.50016V12.5002C11.6001 12.8668 11.9001 13.1668 12.2668 13.1668H13.3334C13.7001 13.1668 14.0001 12.8668 14.0001 12.5002V2.50016C14.0001 2.1335 13.7001 1.8335 13.3334 1.8335Z"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
